<template>
  <page-list
    :list="list"
    :columns="columns"
    :group-actions="groupActions"
    :single-actions="singleActions" />
</template>

<script>
import XLSX from 'xlsx'
import { getTimeTableColumn, getCopyWithContentTableColumn } from '@/utils/common/tableColumn'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import { download } from '@/utils/utils'

export default {
  name: 'LogManageList',
  mixins: [WindowsMixin, ListMixin],
  props: {
    id: {
      type: String,
      required: true,
    },
    logtype: {
      type: String,
      required: true,
      default: 'actions',
    },
    service: {
      type: String,
      required: true,
      default: 'log',
    },
    apiver: {
      type: String,
      required: true,
      default: 'v1',
    },
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: this.logtype + '/splitable',
        apiVersion: this.apiver,
        getParams: {
          service: this.service,
        },
      }),
      columns: [
        getCopyWithContentTableColumn({
          title: this.$t('common.log_table_name'),
          field: 'table',
          hideField: true,
          message: (row) => {
            return row.table || '-'
          },
          slotCallback: (row) => {
            return row.table || '-'
          },
        }),
        getTimeTableColumn({
          field: 'start_date',
          title: this.$t('common.text00119'),
        }),
        getTimeTableColumn({
          field: 'end_date',
          title: this.$t('common.text00120'),
        }),
        {
          field: 'number',
          title: this.$t('scope.text_838'),
          minWidth: 100,
          showOverflow: 'ellipsis',
          slots: {
            default: ({ row }, h) => {
              if (row.count) {
                return this.$t('common_701', [row.count])
              }
              if (row.end <= 0 || (row.end - row.start + 1) < 0) return '-'
              return this.$t('common_701', [row.end - row.start + 1])
            },
          },
        },
        getTimeTableColumn({
          field: 'created_at',
          title: this.$t('common.createdAt'),
        })],
      singleActions: [
        {
          label: this.$t('table.action.export'),
          action: (obj) => {
            this.exportLog(obj)
          },
          meta: (obj) => {
            const ret = {
              validate: true,
              tooltip: null,
            }
            if (!obj.end_date) {
              // ret.validate = false
            }
            return ret
          },
        },
        {
          label: this.$t('system.text_129'),
          action: (obj) => {
            this.createDialog('DeleteResDialog', {
              vm: this,
              data: [obj],
              columns: this.columns,
              title: this.$t('system.text_129'),
              name: this.$t('dictionary.log_manage'),
              ok: async () => {
                try {
                  const manager = new this.$Manager(this.logtype + '/purge-splitable', this.apiver)
                  const response = await manager.batchPost({
                    data: {
                      service: this.service,
                      tables: [obj.table],
                    },
                  })
                  this.list.refresh()
                  return response
                } catch (error) {
                  throw error
                }
              },
            })
          },
          meta: (obj) => {
            const ret = {
              validate: true,
              tooltip: null,
            }
            if (!obj.end_date) {
              ret.validate = false
            }
            return ret
          },
        },
      ],
      groupActions: [
        {
          label: this.$t('system.text_129'),
          action: () => {
            this.createDialog('DeleteResDialog', {
              vm: this,
              data: this.list.selectedItems,
              columns: this.columns,
              title: this.$t('system.text_129'),
              name: this.$t('dictionary.log_manage'),
              ok: async (ids, paramData = []) => {
                try {
                  const manager = new this.$Manager(this.logtype + '/purge-splitable', this.apiver)
                  const response = await manager.batchPost({
                    data: {
                      service: this.service,
                      tables: paramData.map(v => v.table),
                    },
                  })
                  this.list.refresh()
                  return response
                } finally {}
              },
            })
          },
          meta: () => {
            const ret = {
              validate: true,
              tooltip: null,
            }
            for (let i = 0; i < this.list.selectedItems.length; i++) {
              if (!this.list.selectedItems[i].end_date) {
                ret.validate = false
                break
              }
            }
            if (this.list.selectedItems.length === 0) {
              ret.validate = false
              return ret
            }
            return ret
          },
        },
      ],
    }
  },
  created () {
    this.list.fetchData()
  },
  methods: {
    async exportLog (log) {
      try {
        const response = await this.$http({
          methods: 'GET',
          url: `/v1/${this.logtype}/splitable-export`,
          params: {
            service: this.service,
            table: log.table,
            system: this.$store.getters.isAdminMode,
          },
          responseType: 'blob',
          headers: {
            'X-Export-Keys': true,
          },
        })
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'unknown'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) fileName = fileNameMatch[1]
        }
        download(response.data, fileName, response.headers['content-type'])
        // const manager = new this.$Manager(this.logtype, this.apiver)
        // const { data } = await manager.get({
        //   id: 'splitable-export',
        //   params: {
        //     service: this.service,
        //     table: log.table,
        //     system: this.$store.getters.isAdminMode,
        //   },
        // })
        // if (data.length) {
        //   this.saveAsFile(data, log.table)
        // }
      } catch (err) {
        throw err
      }
    },
    getTitles (data) {
      const columns = []
      const titles = []
      const keys = Object.keys(data)
      keys.map(key => {
        const label = this.$te(`common_log_table_key.${key}`) ? this.$t(`common_log_table_key.${key}`) : key
        columns.push({
          field: key,
          label,
        })
        titles.push(label)
      })
      return { titles, columns }
    },
    saveAsFile (data, tableName) {
      const { titles, columns } = this.getTitles(data[0])
      const filename = `${tableName}.xlsx`
      const wb = XLSX.utils.book_new()
      const allLength = data.length
      const sheetMaxLen = 60000 // 每个sheet最多多少条
      let sheetIdx = 1
      let sheetDatas = []
      // 生成sheet
      for (let i = 1; i < allLength + 1; i++) {
        const idx = Math.ceil(i / sheetMaxLen)
        if (idx !== sheetIdx) {
          // 保存旧表
          const ws_name = 'sheet' + sheetIdx
          const ws = XLSX.utils.aoa_to_sheet([titles, ...sheetDatas])
          XLSX.utils.book_append_sheet(wb, ws, ws_name)
          // 插入新表
          sheetIdx = idx
          sheetDatas = []
        } else if (i === allLength) { // 尾表
          const row = []
          columns.map(column => {
            row.push(data[i - 1][column.field] || '')
          })
          sheetDatas.push(row)
          const ws_name = 'sheet' + sheetIdx
          const ws = XLSX.utils.aoa_to_sheet([titles, ...sheetDatas])
          XLSX.utils.book_append_sheet(wb, ws, ws_name)
        }
        // 生成单行数据
        const row = []
        columns.map(column => {
          row.push(data[i - 1][column.field] || '')
        })
        sheetDatas.push(row)
      }
      XLSX.writeFile(wb, filename)
    },
  },
}
</script>
